<template>

  <b-card>
    <b-col cols="12" class="company-tour">
      <h4 class="mb-2">Company Info</h4>
    </b-col>
    <b-col cols="12">
      <validation-observer ref="companyValidation">
        <b-form @submit.prevent="companySubmit">
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Logo</span>
            </b-col>
            <b-col md="4" class="align-self-center">
              <validation-provider
                  #default="{ errors }"
                  name="Business Card (Front)"
                  rules="size:2048|ext:jpeg,png,jpg"
                  vid="business_card_front"
              >
                <b-form-file
                    id="business_card_front"
                    v-model="companyLogoInput"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col v-if="companyLogo" md="2">
              <b-img
                  :src="companyLogo"
                  class="small-image mb-1"
              ></b-img>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Name</span>
            </b-col>
            <b-col md="2" class="align-self-center">
              <!-- name -->

              <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
              >
                <b-form-input
                    id="name"
                    type="text"
                    v-model="companyName"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Website</span>
            </b-col>
            <b-col md="2" class="align-self-center">
              <!-- name -->

              <validation-provider
                  #default="{ errors }"
                  name="website"
                  vid="name"
                  rules="url"
              >
                <b-form-input
                    id="name"
                    type="text"
                    v-model="companyWebsite"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Ex: https://www.taskfino.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Email</span>
            </b-col>
            <b-col md="2" class="align-self-center">
              <!-- name -->

              <validation-provider
                  #default="{ errors }"
                  name="email"
                  vid="email"
              >
                <b-form-input
                    id="email"
                    type="text"
                    v-model="companyEmail"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Company Mobile</span>
            </b-col>
            <b-col md="2" class="align-self-center">
              <!-- name -->

              <validation-provider
                  #default="{ errors }"
                  name="mobile"
                  vid="mobile"
              >
                <b-form-input
                    id="mobile"
                    type="text"
                    v-model="companyMobile"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Mobile"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="2" class="align-self-center">
              <span class="text-nowrap">Company Address</span>
            </b-col>
            <b-col md="4" class="align-self-center">
              <!-- name -->

              <validation-provider
                  #default="{ errors }"
                  name="address"
                  vid="address"
              >
                <b-form-textarea
                    id="address"
                    type="text"
                    v-model="companyAddress"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Address"
                    rows="3"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col md="12" class="align-self-center">
              <!-- loading button -->
              <template v-if="isSettingSubmitLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>

              <!-- submit button -->
              <template v-else>
                <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                >
                  Submit
                </b-button>
              </template>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>

    <b-row>
      <b-col cols="12" class="setting-tour">
        <h4 class="mb-2">Settings Info</h4>
      </b-col>

      <!-- Check In And Out Time -->
      <b-col cols="12">
        <hr class="my-2" />
      </b-col>
      <b-col cols="12">

        <validation-observer ref="companyValidation">
          <b-form @submit.prevent="settingSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Check In Time </span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <validation-provider
                    #default="{ errors }"
                    name="check in"
                    vid="check_in"
                    rules="required"
                >
                  <flat-pickr
                      id="check-in"
                      v-model="checkInTime"
                      class="d-inline-block mr-1"
                      placeholder="09:00 AM"
                      :config="{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: 'H:i:S',
                        altInput: true,
                        altFormat: 'h:i K'
                      }"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Check Out Time </span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <validation-provider
                    #default="{ errors }"
                    name="check out"
                    vid="check_out"
                    rules="required"
                >
                  <flat-pickr
                      id="check-out"
                      v-model="checkOutTime"
                      class="d-inline-block mr-1"
                      placeholder="06:00 PM"
                      :config="{
                  enableTime: true,
                  noCalendar: true,
                  dateFormat: 'H:i:S',
                  altInput: true,
                  altFormat: 'h:i K'
                }"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Work Hours</span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <validation-provider
                    #default="{ errors }"
                    name="work_hours"
                    vid="work_hours"
                >
                  <b-form-group label="Work Hours" label-for="work_hours">
                    <b-form-timepicker
                        id="work_hours"
                        v-model="workHours"
                        locale="en"
                        :hour12="false"
                    />
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Delay Buffer</span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <!-- name -->

                <validation-provider
                    #default="{ errors }"
                    name="Delay Buffer Minutes"
                    vid="delay_buffer_minutes"
                    rules="required|integer"
                >
                  <div class="input-group">
                    <b-form-input
                        id="delay_buffer_minutes"
                        type="number"
                        v-model="delayBufferMinutes"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Delay Buffer Minutes"
                    />
                    <div class="input-group-append">
                        <span
                            id="spamScoreAddon"
                            class="input-group-text"
                        >Min</span>
                    </div>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap"
                >Extreme Delay Buffer</span
                >
              </b-col>
              <b-col md="3" class="align-self-center">
                <!-- name -->

                <validation-provider
                    #default="{ errors }"
                    name="Extreme Delay Buffer Minutes"
                    vid="extreme_delay_buffer_minutes"
                    rules="required|integer"
                >
                  <div class="input-group">
                    <b-form-input
                        id="extreme_delay_buffer_minutes"
                        type="number"
                        v-model="extremeDelayBufferMinutes"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Extreme Delay Buffer Minutes"
                    />
                    <div class="input-group-append">
                          <span
                              id="spamScoreAddon"
                              class="input-group-text"
                          >Min</span>
                    </div>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Over Time</span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <!-- name -->

                <validation-provider
                    #default="{ errors }"
                    name="Over Time Minutes"
                    vid="over_time_minutes"
                    rules="required|integer"
                >
                  <div class="input-group">
                    <b-form-input
                        id="over_time_minutes"
                        type="number"
                        v-model="overTimeMinutes"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Over Time Minutes"
                    />
                    <div class="input-group-append">
                          <span
                              id="spamScoreAddon"
                              class="input-group-text"
                          >Min</span>
                    </div>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="2" class="align-self-center">
                <span class="text-nowrap">Minimum Over Time</span>
              </b-col>
              <b-col md="3" class="align-self-center">
                <!-- name -->

                <validation-provider
                    #default="{ errors }"
                    name="Minimum Over Time Minutes"
                    vid="min_over_time_minutes"
                    rules="required|integer"
                >
                  <div class="input-group">
                    <b-form-input
                        id="min_over_time_minutes"
                        type="number"
                        v-model="minOverTimeMinutes"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Minimum Over Time Minutes"
                    />
                    <div class="input-group-append">
                          <span
                              id="spamScoreAddon"
                              class="input-group-text"
                          >Min</span>
                    </div>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="align-self-center">
                <!-- loading button -->
                <template v-if="isSettingSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                      type="submit"
                      class="float-right"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>

      <!-- invoice -->
      <b-col cols="12">
        <hr class="my-2" />
      </b-col>
      <b-col cols="12" class="invoice-tour">
        <h4 class="mb-2">
          Invoice Number Generate: #<b-badge pill variant="primary">
            {{ invoicePrefix + invoiceCode }}
          </b-badge>
        </h4>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="invoicePrefixValidation">
          <b-form @submit.prevent="onInvoicePrefixSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <!-- name -->
                <b-form-group label="Invoice Prefix" label-for="invoice-prefix">
                  <validation-provider
                    #default="{ errors }"
                    name="invoice_prefix"
                    vid="invoice_prefix"
                    rules="required|max:255"
                  >
                    <b-form-input
                      id="invoice-prefix"
                      type="text"
                      v-model="invoicePrefix"
                      :state="errors.length > 0 ? false : null"
                      placeholder="INV"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isInvoicePrefixSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="invoiceCodeValidation">
          <b-form @submit.prevent="onInvoiceCodeSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <!-- name -->
                <b-form-group label="Invoice Code" label-for="invoice-code">
                  <validation-provider
                    #default="{ errors }"
                    name="invoice_code"
                    vid="invoice_code"
                    rules="required|integer"
                  >
                    <b-form-input
                      id="invoice-code"
                      type="number"
                      v-model="invoiceCode"
                      :state="errors.length > 0 ? false : null"
                      placeholder="1000"
                      :disabled="isDisableInvoiceCode"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isInvoiceCodeSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    :disabled="isDisableInvoiceCode"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
      <!-- payslip -->
      <b-col cols="12">
        <hr class="my-2" />
      </b-col>
      <b-col cols="12" class="payslip-tour">
        <h4 class="mb-2">
          Payslip Number Generate: #<b-badge pill variant="primary">
            {{ payslipPrefix + payslipCode }}
          </b-badge>
        </h4>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="payslipPrefixValidation">
          <b-form @submit.prevent="onPayslipPrefixSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <!-- name -->
                <b-form-group label="Invoice Prefix" label-for="payslip-prefix">
                  <validation-provider
                    #default="{ errors }"
                    name="payslip_prefix"
                    vid="payslip_prefix"
                    rules="required|max:255"
                  >
                    <b-form-input
                      id="payslip-prefix"
                      type="text"
                      v-model="payslipPrefix"
                      :state="errors.length > 0 ? false : null"
                      placeholder="PAY"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isPayslipPrefixSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="payslipCodeValidation">
          <b-form @submit.prevent="onPayslipCodeSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <!-- name -->
                <b-form-group label="Payslip Code" label-for="payslip-code">
                  <validation-provider
                    #default="{ errors }"
                    name="payslip_code"
                    vid="payslip_code"
                    rules="required|integer"
                  >
                    <b-form-input
                      id="payslip-code"
                      type="number"
                      v-model="payslipCode"
                      :state="errors.length > 0 ? false : null"
                      placeholder="1000"
                      :disabled="isDisablePayslipCode"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isPayslipCodeSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    :disabled="isDisablePayslipCode"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>
      <!-- Check In And Out Time -->
      <b-col cols="12">
        <hr class="my-2" />
      </b-col>
      <b-col cols="12" class="default-account-tour">
        <h4 class="mb-2">Default Account:</h4>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="defaultAccountValidation">
          <b-form @submit.prevent="onDefaultAccountSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <b-form-group label="Account" label-for="account-id">
                  <ValidationProvider
                    name="account"
                    v-slot="{ errors }"
                    vid="account_id"
                    rules="required"
                  >
                    <v-select
                      id="account-id"
                      v-model="selectAccountId"
                      :options="accountsOption"
                      :reduce="(option) => option.id"
                      label="name"
                      placeholder="Choose a account"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isDefaultAccountSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>

      <b-col cols="12">
        <hr class="my-2" />
      </b-col>

      <b-col cols="12" class="default-currency-tour">
        <h4 class="mb-2">Default Currency:</h4>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="defaultAccountValidation">
          <b-form @submit.prevent="onDefaultCurrencySubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <b-form-group label="Currency" label-for="account-id">
                  <ValidationProvider
                    name="currency"
                    v-slot="{ errors }"
                    vid="currency_id"
                    rules="required"
                  >
                    <v-select
                      id="currency-id"
                      v-model="selectCurrencyId"
                      :options="currenciesOption"
                      :reduce="(option) => option.id"
                      label="name"
                      placeholder="Choose a currency"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col md="10" class="align-self-center">
                <!-- loading button -->
                <template v-if="isDefaultCurrencySubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>

      <b-col cols="12">
        <hr class="my-2" />
      </b-col>

      <b-col cols="12" class="default-fiscal-year-tour">
        <h4 class="mb-2">Default Fiscal year:</h4>
      </b-col>
      <b-col cols="12">
        <validation-observer ref="defaultFiscalYearValidation">
          <b-form @submit.prevent="onDefaultFiscalYearSubmit">
            <b-row>
              <b-col md="2" class="align-self-center">
                <b-form-group label="Start Month" label-for="month">
                  <ValidationProvider
                    name="fiscalStartMonth"
                    v-slot="{ errors }"
                    vid="fiscalStartMonth"
                    rules="required"
                  >
                    <v-select
                      id="fiscalStartMonth"
                      v-model="selectFiscalStartMonth"
                      :options="monthNameConstants"
                      :reduce="(option) => option.value"
                      label="name"
                      placeholder="Choose a month"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col md="2" class="align-self-center">
                <b-form-group label="Next Month" label-for="month">
                  <ValidationProvider
                    name="fiscalEndMonth"
                    v-slot="{ errors }"
                    vid="fiscalEndMonth"
                    rules="required"
                  >
                    <v-select
                      id="fiscalEndMonth"
                      v-model="selectFiscalEndMonth"
                      :options="monthNameConstants"
                      :reduce="(option) => option.value"
                      label="name"
                      placeholder="Choose a month"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col md="8" class="align-self-center">
                <!-- loading button -->
                <template v-if="isFiscalYearSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>

      <b-col cols="12">
        <hr class="my-2" />
      </b-col>

      <b-col cols="12" class="default-date-tour">
        <h4 class="mb-2">Default Date Format:</h4>
      </b-col>

      <b-col cols="12">
        <validation-observer ref="defaultDateFormatValidation">
          <b-form @submit.prevent="onDefaultDateFormatSubmit">
            <b-row>
              <b-col md="3" class="align-self-center">
                <b-form-group label="Select a date format" label-for="dateFormat">
                  <ValidationProvider
                    name="dateFormat"
                    v-slot="{ errors }"
                    vid="dateFormat"
                    rules="required"
                  >
                    <v-select
                      id="dateFormat"
                      v-model="selectDateFormat"
                      :options="dateFormatConstants"
                      :reduce="(option) => option.value"
                      label="name"
                      placeholder="Choose a format"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col md="9" class="align-self-center">
                <!-- loading button -->
                <template v-if="isSelectDateFormatSubmitLoading">
                  <b-button class="float-right" variant="primary" disabled>
                    <b-spinner small />
                    Loading...
                  </b-button>
                </template>

                <!-- submit button -->
                <template v-else>
                  <b-button
                    type="submit"
                    class="float-right"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                  >
                    Submit
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-col>





    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BBadge,
  BForm,
  BFormCheckbox,
  BCol,
  BRow,
  BButton,
  BFormTimepicker,
  BFormGroup,
  BSpinner,
  BFormInput,
  BCardText,
  BFormTextarea, BImg, BFormFile,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, integer } from "@validations";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { monthNameConstants } from "@/helpers/constant/monthNameConstant";
import { dateFormatConstants } from "@/helpers/constant/dateFormatConstant";
import store from '@/store'
import {mapGetters} from "vuex";
import IntroJs from 'intro.js';
import 'intro.js/introjs.css';
import {EventBus} from "@/helpers/event-bus";
import flatPickr from 'vue-flatpickr-component'

export default {
  name: "GeneralSettingView",
  components: {
    BFormFile,
    BImg,
    BForm,
    BCard,
    BBadge,
    BFormCheckbox,
    BCol,
    BRow,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
    BFormGroup,
    BSpinner,
    BFormInput,
    BCardText,
    BFormTextarea,
    DatePicker,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      settingSteps: [
        {
          element: '.company-tour',
          intro: `Setup company's details including name, logo, address.`
        },
        {
          element: '.setting-tour',
          intro: `Configure your company's basic settings for check-in, check-out time, over time settings and more.`
        },
        {
          element: '.invoice-tour',
          intro: `Set up and customize your invoicing preferences in the Invoice section.`
        },
        {
          element: '.payslip-tour',
          intro: `Manage your payroll settings in the Payslip section.`
        },
        {
          element: '.default-account-tour',
          intro: `Set the default bank account for handling transactions.`
        },
        {
          element: '.default-currency-tour',
          intro: `Set the default currency for transactions across your application. You can choose the base currency for your company's financial operations in the Currency section.`
        },
        {
          element: '.default-fiscal-year-tour',
          intro: `Define the start and end dates for your company's fiscal year. This will be used for financial reporting and budgeting purposes.`
        },
        {
          element: '.default-date-tour',
          intro: `Set the default date formats and preferences that will be used throughout the application for consistency in record-keeping and reporting.`
        }
      ],

      checkInTime: '',
      checkOutTime: '',
      companyLogo: null,
      companyLogoInput: null,
      companyLogoSubmitLoading: false,
      isCheckInOutTimeSubmitLoading: false,
      isSettingSubmitLoading: false,
      isCompanySubmitLoading: false,
      // invoice
      invoicePrefix: "",
      isInvoicePrefixSubmitLoading: false,
      invoiceCode: "",
      isInvoiceCodeSubmitLoading: false,
      isDisableInvoiceCode: false,
      // payslip
      payslipPrefix: "",
      isPayslipPrefixSubmitLoading: false,
      payslipCode: "",
      isPayslipCodeSubmitLoading: false,
      isDisablePayslipCode: false,
      // account
      selectAccountId: "",
      accountsOption: [],
      isDefaultAccountSubmitLoading: false,
      // delayBufferMinutes
      isDelayBufferMinutesSubmitLoading: false,
      delayBufferMinutes: "",
      // extreme delayBufferMinutes
      isExtremeDelayBufferMinutesSubmitLoading: false,
      extremeDelayBufferMinutes: "",

      // overTimeMinutes
      isOverTimeMinutesSubmitLoading: false,
      overTimeMinutes: "",
      // overTimeMinutes

      // minimum overTimeMinutes
      isMinOverTimeMinutesSubmitLoading: false,
      minOverTimeMinutes: "",
      // overTimeMinutes

      isWorkHoursSubmitLoading: false,
      workHours: "",
      //company address
      companyAddress: "",
      isAddressSubmitLoading: false,
      //company email
      companyEmail: "",
      isEmailSubmitLoading: false,

      //company email
      companyName: "",
      isNameSubmitLoading: false,

      //company mobile
      companyMobile: "",
      companyWebsite: "",
      isMobileSubmitLoading: false,
      // currency
      selectCurrencyId: "",
      currenciesOption: [],
      isDefaultCurrencySubmitLoading: false,

      //Fiscal Year
      selectFiscalStartMonth: "",
      selectFiscalEndMonth: "",
      isFiscalYearSubmitLoading: false,

      monthNameConstants,

      //Date Format
      dateFormatConstants,
      selectDateFormat: "",
      isSelectDateFormatSubmitLoading: false,

    };
  },

  mounted() {

    EventBus.$on('start-setting-tour', () => {
      this.startTour()
    })

    setTimeout(() => {
      if (!this.authUser?.settingsVisited) {
          this.startTour()
        // Call API to mark settings as visited
        this.$api.put(`api/users/settings-visited`);
      }
    }, 500)
  },

  computed: {
    ...mapGetters({
      authUser: "userModule/getUser",
    }),
  },

  async created() {
    try {
      const [getSetting, getInvoiceSetting, getAccounts, getCurrencies, company] =
        await Promise.all([
          this.getSetting({
            select:
              "check_in_time,check_out_time,account_id,currency_id,delay_buffer_minutes,over_time_minutes,minimum_over_time_minutes,work_hours,extreme_delay_buffer_minutes,fiscal_start_month,fiscal_end_month,date_format",
          }),
          this.getInvoiceSetting(),
          this.getAccounts(),
          this.getCurrencies(),
          this.getCompany(),
        ]);

      // getSetting
      this.checkInTime = getSetting?.data?.data?.check_in_time;
      this.checkOutTime = getSetting?.data?.data?.check_out_time;
      this.selectAccountId = getSetting?.data?.data?.account_id;
      this.selectCurrencyId = getSetting?.data?.data?.currency_id;
      this.selectFiscalStartMonth = getSetting?.data?.data?.fiscal_start_month;
      this.selectFiscalEndMonth = getSetting?.data?.data?.fiscal_end_month;
      this.selectDateFormat = getSetting?.data?.data?.date_format;

      this.companyLogo = company?.data?.data?.logo;
      this.companyAddress = company?.data?.data?.address;
      this.companyEmail = company?.data?.data?.email;
      this.companyName = company?.data?.data?.name;
      this.companyMobile = company?.data?.data?.contact_no;
      this.companyWebsite = company?.data?.data?.website;

      // getInvoicePrefix
      this.invoicePrefix = getInvoiceSetting?.data?.data?.invoice_prefix;
      this.invoiceCode = getInvoiceSetting?.data?.data?.invoice_code;
      this.isDisableInvoiceCode = getInvoiceSetting?.data?.data?.ic_status;

      // Payslip
      this.payslipPrefix = getInvoiceSetting?.data?.data?.payslip_prefix;
      this.payslipCode = getInvoiceSetting?.data?.data?.payslip_code;
      this.isDisablePayslipCode = getInvoiceSetting?.data?.data?.pc_status;

      // delay_buffer_minutes
      this.delayBufferMinutes =
        getSetting?.data?.data?.delay_buffer_minutes?.toString();

      // extreme_delay_buffer_minutes
      this.extremeDelayBufferMinutes =
        getSetting?.data?.data?.extreme_delay_buffer_minutes?.toString();

      // over_time_minutes
      this.overTimeMinutes =
        getSetting?.data?.data?.over_time_minutes?.toString();

      this.minOverTimeMinutes =
        getSetting?.data?.data?.minimum_over_time_minutes?.toString();

      // work_hours
      this.workHours = getSetting?.data?.data?.work_hours;

      // getAccounts
      this.accountsOption = getAccounts?.data?.data?.map((item) => {
        let name = `${item?.name} (${item?.currency} ${item?.balance})`;
        return {
          name,
          id: item?.id,
        };
      });

      // getCurrencies
      this.currenciesOption = getCurrencies?.data?.data?.map((item) => {
        let name = `${item?.currency}`;
        return {
          name,
          id: item?.id,
        };
      });
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },
  methods: {

    startTour(){
      this.settingSteps = this.settingSteps.filter(step => document.querySelector(step.element))

      const intro = IntroJs();
      intro.setOptions({
        steps: this.settingSteps,
        showStepNumbers: true,
        showBullets: true,
        exitOnOverlayClick: false,
        hidePrev: true,
        hideNext: true,
        nextToDone: true,
        prevLabel: 'Prev',
        nextLabel: 'Next',
      });
      intro.start();
    },
    async getSetting(params) {
      return await this.$api.get("/api/settings", {
        params: {
          select: params.select,
        },
      });
    },
    async getInvoiceSetting() {
      return await this.$api.get("/api/settings/invoice");
    },
    async getAccounts() {
      return await this.$api.get("/api/accounts/active/all");
    },
    async getCompany() {
      return await this.$api.get("/api/companies/current");
    },
    async getCurrencies() {
      return await this.$api.get("/api/currencies/all");
    },
    async onWorkHoursSubmit() {
      this.$refs.workHoursValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.isWorkHoursSubmitLoading = true;
            await this.$api.put("/api/settings/update", {
              work_hours: this.workHours,
            });
            this.isWorkHoursSubmitLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Work Hours successfully updated",
              },
            });
          } catch (error) {
            this.isWorkHoursSubmitLoading = false;

            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.workHoursValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },
    async companySubmit() {

      if (!this.$refs.companyValidation) return;

      const success = await this.$refs.companyValidation.validate();
      if (!success) return;

      try {
        this.isSettingSubmitLoading = true;

        // Use FormData for handling file uploads
        const formData = new FormData();
        formData.append("_method", "PUT");

        if(this.companyAddress)
        {
          formData.append("address", this.companyAddress);
        }

        if(this.companyName)
        {
          formData.append("name", this.companyName);
        }

        if(this.companyEmail){
          formData.append("email", this.companyEmail);
        }

        if(this.companyMobile){
          formData.append("contact_no", this.companyMobile);
        }

        if(this.companyWebsite){
          formData.append("website", this.companyWebsite);
        }

        //Check if company logo is available and append it
        if (this.companyLogoInput) {
          formData.append("logo", this.companyLogoInput);
        }

        const response = await this.$api.post("/api/companies/" + this.authUser?.company_id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // Update company logo if available in response
        this.companyLogo = response.data.data.logo;

        this.$store.commit("companyModule/setData", {
          name: response.data.data.name,
          email: response.data.data.email,
          contact_no: response.data.data.contact_no,
          website: response.data.data.website,
          logo: response.data.data.logo,
        });

        this.$store.commit("authModule/setCompanyLogo", {
          companyLogo: this.companyLogo
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Company successfully updated",
          },
        });
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: error.response.data.message,
            },
          });
        }

        if (error?.response?.data?.errors) {
          Object.entries(error.response.data.errors).forEach(([field, messages]) => {
            if (this.$refs[field]) {
              this.$refs[field].setErrors(messages);
            }
          });
        }
      } finally {
        this.isSettingSubmitLoading = false;
      }
    },

    async settingSubmit() {
      if (!this.$refs.companyValidation) return;

      const success = await this.$refs.companyValidation.validate();
      if (!success) return;

      try {
        this.isSettingSubmitLoading = true;

        // Use FormData for handling file uploads
        const formData = new FormData();
        formData.append("_method", "PUT");

        formData.append("check_in_time", this.checkInTime);
        formData.append("check_out_time", this.checkOutTime);
        formData.append("work_hours", this.workHours);
        formData.append("extreme_delay_buffer_minutes", this.extremeDelayBufferMinutes);
        formData.append("delay_buffer_minutes", this.delayBufferMinutes);
        formData.append("over_time_minutes", this.overTimeMinutes);
        formData.append("min_over_time_minutes", this.minOverTimeMinutes);

        const response = await this.$api.post(`/api/settings/update`, formData);

        // Update company logo if available in response
        this.companyLogo = response.data.data.logo;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Settings successfully updated",
          },
        });
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: error.response.data.message,
            },
          });
        }

        if (error?.response?.data?.errors) {
          Object.entries(error.response.data.errors).forEach(([field, messages]) => {
            if (this.$refs[field]) {
              this.$refs[field].setErrors(messages);
            }
          });
        }
      } finally {
        this.isSettingSubmitLoading = false;
      }
    },

    async onInvoicePrefixSubmit() {
      this.$refs.invoicePrefixValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.isInvoicePrefixSubmitLoading = true;
            await this.$api.put("/api/settings/invoice/inv/prefix/update", {
              invoice_prefix: this.invoicePrefix,
            });
            this.isInvoicePrefixSubmitLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Invoice Prefix Successfully Updated",
              },
            });
          } catch (error) {
            this.isInvoicePrefixSubmitLoading = false;

            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.invoicePrefixValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },

    async onInvoiceCodeSubmit() {
      this.$refs.invoiceCodeValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Generate Invoice Code?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isInvoiceCodeSubmitLoading = true;
                await this.$api.put("/api/settings/invoice/inv/code/update", {
                  invoice_code: this.invoiceCode,
                });
                this.isDisableInvoiceCode = true;
                this.isInvoiceCodeSubmitLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Invoice Code Successfully Updated",
                  },
                });
              } catch (error) {
                this.isInvoiceCodeSubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.invoiceCodeValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },

    async onPayslipPrefixSubmit() {
      this.$refs.payslipPrefixValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.isPayslipPrefixSubmitLoading = true;
            await this.$api.put("/api/settings/invoice/pay/prefix/update", {
              payslip_prefix: this.payslipPrefix,
            });
            this.isPayslipPrefixSubmitLoading = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Payslip Prefix Successfully Updated",
              },
            });
          } catch (error) {
            this.isPayslipPrefixSubmitLoading = false;

            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.payslipPrefixValidation.setErrors(
                error?.response?.data?.errors
              );
            }
          }
        }
      });
    },

    async onPayslipCodeSubmit() {
      this.$refs.payslipCodeValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Generate Payslip Code?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isPayslipCodeSubmitLoading = true;
                await this.$api.put("/api/settings/invoice/pay/code/update", {
                  payslip_code: this.payslipCode,
                });
                this.isDisablePayslipCode = true;
                this.isPayslipCodeSubmitLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Payslip Code Successfully Updated",
                  },
                });
              } catch (error) {
                this.isPayslipCodeSubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.payslipCodeValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },

    async onDefaultAccountSubmit() {
      this.$refs.defaultAccountValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Set Default Account?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isDefaultAccountSubmitLoading = true;
                await this.$api.put("/api/settings/update", {
                  account_id: this.selectAccountId,
                });
                this.isDefaultAccountSubmitLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Default Account Successfully Updated",
                  },
                });
              } catch (error) {
                this.isDefaultAccountSubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.defaultAccountValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },

    async onDefaultCurrencySubmit() {
      this.$refs.defaultAccountValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Set Default Currency?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isDefaultCurrencySubmitLoading = true;
                await this.$api.put("/api/settings/update", {
                  currency_id: this.selectCurrencyId,
                });
                this.isDefaultCurrencySubmitLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Default Currency Successfully Updated",
                  },
                });
              } catch (error) {
                this.isDefaultCurrencySubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.defaultAccountValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },

    async onDefaultFiscalYearSubmit() {
      this.$refs.defaultFiscalYearValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Set Default Fiscal Year?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isFiscalYearSubmitLoading = true;
                await this.$api.put("/api/settings/update", {
                  fiscal_start_month: this.selectFiscalStartMonth,
                  fiscal_end_month: this.selectFiscalEndMonth,
                });
                this.isFiscalYearSubmitLoading = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Default Fiscal Year Successfully Updated",
                  },
                });
              } catch (error) {
                this.isFiscalYearSubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.defaultFiscalYearValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },

    async onDefaultDateFormatSubmit() {
      this.$refs.defaultDateFormatValidation.validate().then(async (success) => {
        if (success) {
          this.$swal({
            title: "Warning!",
            text: "Are You Sure You Want To Set Default Date Format?",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Ok",
            showLoaderOnConfirm: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.isSelectDateFormatSubmitLoading = true;
                const settings = await this.$api.put("/api/settings/update", {
                  date_format: this.selectDateFormat,
                });
                this.isSelectDateFormatSubmitLoading = false;
                store.commit("app/setGlobalDateFormat", settings?.data?.data?.date_format)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Default Date Format Successfully Updated",
                  },
                });
              } catch (error) {
                this.isSelectDateFormatSubmitLoading = false;

                if (error?.response?.data?.message) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: error?.response?.data?.message,
                    },
                  });
                }

                if (error?.response?.data?.errors) {
                  this.$refs.defaultFiscalYearValidation.setErrors(
                    error?.response?.data?.errors
                  );
                }
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";


.small-image {
  max-width: 150px; /* Limits the width to make the image smaller */
  height: auto; /* Maintains the aspect ratio */
}
</style>
